import { EventCodeModel } from './eventcode-model';
import { GuestModel } from './guest-model';
import { GuestGroupModel } from './guestgroup-model';
import { TopicMessageModel } from './topic-message-model';

export class TopicModel {

    constructor(readonly eventCode: string,
                readonly key: string,
                readonly title: string,
                readonly firstMessage: TopicMessageModel,
                readonly lastMessage: TopicMessageModel,
                readonly messageCount: number){
    }
}


// WEBPACK FOOTER //
// ./src/app/models/topic-model.ts